import { useEffect, useState } from "react";

const tickers = [
  "玩法快讯 · 倍速模块新增「片段循环」，追梗回放更顺滑",
  "去水印新增 4K 画质档，原画直存更清晰",
  "弹幕聚合现已支持双平台同屏对齐，同步开聊",
  "录屏新增「直播跟随」，自动分段，长时录制更省心",
  "解析通道扩容，高峰期出片更稳，吃瓜不排队",
];

const navLinks = [
  { label: "玩法总览", href: "#play" },
  { label: "玩法快讯", href: "#flash" },
  { label: "今日热榜", href: "#rank" },
  { label: "操作指南", href: "#guide" },
  { label: "妙用场景", href: "#scene" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      {/* 顶部快讯条：厚运营壳 */}
      <div className="overflow-hidden bg-primary-500 text-background-50">
        <div className="marquee-track py-1.5 text-xs">
          {[...tickers, ...tickers].map((t, i) => (
            <span key={i} className="flex items-center gap-3 whitespace-nowrap px-4">
              <i className="ri-flashlight-line" />
              <span>{t}</span>
              <span className="opacity-50">✦</span>
            </span>
          ))}
        </div>
      </div>

      {/* 主导航 */}
      <nav
        className={`transition-all duration-300 ${
          scrolled ? "bg-background-50/95 shadow-sm backdrop-blur" : "bg-background-50"
        }`}
      >
        <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 md:px-6">
          <div className="flex items-center gap-2">
            <h1 className="text-xl md:text-2xl">
              <a href="#top" className="flex items-center gap-2 text-foreground-950">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-water-flash-line text-base" />
                </span>
                <span className="whitespace-nowrap font-heading font-bold">
                  吃瓜神器
                </span>
              </a>
            </h1>
            <span className="ml-1 hidden whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-800 sm:inline-block">
              玩法专题合集
            </span>
          </div>

          {/* 桌面导航 */}
          <div className="hidden items-center gap-1 md:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="hidden items-center gap-3 md:flex">
            <a
              href="#rank"
              className="flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900"
            >
              <i className="ri-fire-line text-accent-500" />
              热度飙升中
            </a>
            <a
              href="#guide"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              开始吃瓜
            </a>
          </div>

          {/* 移动端汉堡 */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-900 md:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>

        {/* 移动端菜单 */}
        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
            <div className="flex flex-col gap-1 pt-3">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-secondary-100"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#guide"
                onClick={() => setOpen(false)}
                className="mt-2 rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
              >
                开始吃瓜
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}